import { defineAsyncComponent } from 'vue'
export default {
  menu: defineAsyncComponent(() => import("/home/docker/layouts/menu.vue").then(m => m.default || m)),
  v1: defineAsyncComponent(() => import("/home/docker/layouts/v1.vue").then(m => m.default || m)),
  v2: defineAsyncComponent(() => import("/home/docker/layouts/v2.vue").then(m => m.default || m))
}